
import HeroSection from './components/HeroSection';
import IntroSection from './components/IntroSection';
import ProviderNetwork from './components/ProviderNetwork';
import InsurancePlansPreview from './components/CareLevelsPreview';
import TrustSection from './components/TrustSection';
import WhyChooseUs from './components/CommunityHighlights';
import TestimonialCarousel from './components/TestimonialCarousel';
import FinalCTA from './components/FinalCTA';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <HeroSection />
      <IntroSection />
      <ProviderNetwork />
      <TrustSection />
      <InsurancePlansPreview />
      <WhyChooseUs />
      <TestimonialCarousel />
      <FinalCTA />
    </div>
  );
}
